import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(
    `${process.env.REACT_APP_API_HOST}/resume_experience/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const get = async (id) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/resume_experience/${id}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(
    `${process.env.REACT_APP_API_HOST}/resume_experience/${id}/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const remove = async (id) => {
  return await httpClient.delete(
    `${process.env.REACT_APP_API_HOST}/resume_experience/${id}`,
  );
};

const filter = async (query) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/resume_experience${query}`,
  );
};

const ajaxTable = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  _exportCSV = false,
) => {
  return await httpClient.get(`resume_experience/`, {
    params: Object.assign(
      {
        'filter[tercero]': query,
        'page[number]': page,
        'page[size]': pageSize,
      },
      search ? { 'filter[search]': search } : {},
    ),
  });
};

export { post, get, put, remove, filter, ajaxTable };
